import { render, staticRenderFns } from "./Many2OneField.vue?vue&type=template&id=290a128a&scoped=true"
import script from "./Many2OneField.vue?vue&type=script&lang=js"
export * from "./Many2OneField.vue?vue&type=script&lang=js"
import style0 from "./Many2OneField.vue?vue&type=style&index=0&id=290a128a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a128a",
  null
  
)

export default component.exports